import { render, staticRenderFns } from "./TimesCardTypeForm.vue?vue&type=template&id=1b94e385&scoped=true&"
import script from "./TimesCardTypeForm.vue?vue&type=script&lang=js&"
export * from "./TimesCardTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b94e385",
  null
  
)

export default component.exports